export default "__VITE_ASSET__5360d71c__"